<script>
import {api} from "@/modules/api";
import {cart} from "@/modules/cart";
import DetailsProduct from "@/components/products/viewProduct/DetailsProduct.vue";

export default {
  name: 'ViewProduct',
  components: {DetailsProduct},
  computed: {
    cart() {
      return cart
    }
  },
  data () {
    return {
      product: {}
    }
  },
  mounted () {
    this.loadData()
    this.emitter.on('load-data', () => {
      this.loadData()
    })
  },
  methods: {
    async loadData () {
      const tag = this.$route.params.tag
      api.products.getById(tag).then((response) => {
        if (response.status === 404) {
          this.$router.push('/boutique')
        }
        this.product = response
      }).catch(() => {
        this.$router.push('/boutique')
      })
    }
  }
}
</script>

<template>
  <section class="py-8 bg-white md:py-16 dark:bg-gray-900 antialiased">
    <details-product v-if="product.id" :product="product" />
  </section>
</template>
